import { handleDocumentOnDevice } from "web_myplann/Api/Document/handleDocumentOnDevice";
import { openDocumentInBrowser } from "web_myplann/Api/Document/openDocumentInBrowser";
import { useDocumentMutation } from "web_myplann/Api/Document/useDocumentMutation";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { isEmbeddedInFrame } from "web_myplann/Utils/device";
import { HandleDocumentTypes } from "web_myplann/Utils/WebViewModel";

export const useOpenDocumentMutation = () =>
	useDocumentMutation<void>({
		errorResource: Resources.Common.documentOpenFailed,
		deliver: async (document, errorMessage) => {
			if (isEmbeddedInFrame) {
				openDocumentInBrowser(document);
				return;
			}

			await handleDocumentOnDevice({
				base64: document.base64,
				filename: document.filename,
				mimeType: document.mimeType,
				actionType: HandleDocumentTypes.OPEN,
				errorMessage,
			});
		},
	});
